var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c(_vm.componentSwitch,{tag:"component",attrs:{"type":_vm.type},on:{"switchView":_vm.handleSwitchView,"goBack":function($event){return _vm.$emit('navBack')}},model:{value:(_vm.selectedTask),callback:function ($$v) {_vm.selectedTask=$$v},expression:"selectedTask"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }